export default "__VITE_ASSET__CRnOcrTk__"